import React, { useState, createContext, useEffect } from 'react'
import AccountCreateTour from '../components/Tours/AccountCreateTour'
import NewUserTour from '../components/Tours/NewUserTour'
import TeamLeadTour from '../components/Tours/TeamLeadTour'
import TeamMemberTour from '../components/Tours/TeamMemberTour'
import { withUserStore } from './UserStore'

const TourContext = createContext({})

export const withTour = ComponentWithTour => props => (
  <TourContext.Consumer>
    {({ tourActions }) => <ComponentWithTour tourActions={tourActions} {...props} />}
  </TourContext.Consumer>
)

// Separate component to detect when tours should auto-show
const TourTriggerDetector = ({ userStore, tourActions }) => {
  const [hasCheckedAutoTour, setHasCheckedAutoTour] = useState(false)

  useEffect(() => {
    if (!userStore || !userStore.account || hasCheckedAutoTour) return

    // Skip auto-showing tour if we're in a test environment
    if (window.Cypress || window.location.search.includes('test')) return

    const priorities = userStore.getRecords('priorities') || []
    const strategies = userStore.getRecords('strategies') || []
    const goals = userStore.getRecords('goals') || []

    // Show AccountCreateTour if account has no priorities, strategies, or goals
    if (priorities.length === 0 && strategies.length === 0 && goals.length === 0) {
      tourActions.setShowTour('AccountCreateTour')
      setHasCheckedAutoTour(true)
    }
  }, [userStore?.account, hasCheckedAutoTour, tourActions])

  return null // This component just detects, doesn't render anything
}

const TourTriggerDetectorWithStore = withUserStore(TourTriggerDetector)

const Tours = props => {
  const [showTour, setShowTour] = useState(null)
  const tourActions = {
    setShowTour: (tourName) => {
      setShowTour(tourName)
    },
    showTour: () => showTour
  }

  return (
    <TourContext.Provider value={{ tourActions: tourActions }}>
      {/* Detector for auto-triggering tours based on conditions */}
      <TourTriggerDetectorWithStore tourActions={tourActions} />

      {/* Conditionally render tour components only when active to avoid lifecycle conflicts */}
      {showTour === 'AccountCreateTour' && <AccountCreateTour tourActions={tourActions} />}
      {showTour === 'NewUserTour' && <NewUserTour tourActions={tourActions} />}
      {showTour === 'TeamLeadTour' && <TeamLeadTour tourActions={tourActions} />}
      {showTour === 'TeamMemberTour' && <TeamMemberTour tourActions={tourActions} />}

      {props.children}
    </TourContext.Provider>
  )
}

export default Tours
